import React, { useEffect } from "react";
import { Container, Typography, Box } from "@mui/material";
import { styled } from "@mui/system";
import { ButtonLink } from "./Styled";
import { routeLinks } from "constants/paths";
import { companyDetailsApi } from "API/apis/user/companyDetails";
import { useNavigate } from "react-router-dom";

const MaintenanceWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  textAlign: "center",
});

export const UnderMaintenance = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const fetchMaintenanceStatus = async () => {
      const { data } = await companyDetailsApi();
      if (!data[0].isUnderMaintenance) {
        navigate("/");
      }
    };
    const intervalId = setInterval(fetchMaintenanceStatus, 15 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);
  return (
    <Container>
      <MaintenanceWrapper>
        <Typography variant="h3" color="primary" gutterBottom>
          🚧 Under Maintenance 🚧
        </Typography>
        <Typography variant="h6" color="textSecondary">
          We are currently performing scheduled maintenance. <br />
          Please check back in 10–15 minutes. <br />
          Thank you!
        </Typography>
        <ButtonLink variant="contained" href={routeLinks.dashboardCommon}>
          Return to Homepage
        </ButtonLink>
      </MaintenanceWrapper>
    </Container>
  );
};
